const pl = {
  placeholder: {
    desktopOnlyTitle: "Otwórz na większym ekranie",
    desktopOnlyDescription:
      "Ten widok potrzebuje więcej miejsca, niż daje telefon.\nOtwórz go na tablecie lub komputerze.",
  },
  common: {
    rangeMinimum: "{{variable}} minimum",
    rangeMaximum: "{{variable}} maksimum",
    selectItem: "Zaznacz {{variable}}",
    cancel: "Anuluj",
    confirm: "Potwierdź",
    edit: "Edytuj",
    save: "Zapisz",
    apply: "Zastosuj",
    continue: "Kontynuuj",
    selected: "zaznaczono",
    searchPlaceholder: "Szukaj...",
    fileUploadPlaceholder: "Wybierz plik lub przeciągnij tutaj",
    fileUploadAction: "Wybierz plik",
    fileSizeOf: "z",
    fileUploading: "Pobieranie...",
    fileUploadRetry: "Spróbuj ponownie",
    remove: "Usuń",
    range: "Zakres",
    feature: "Funkcja",
    periodRange: "Zakres dat",
    more: "Więcej",
    actions: "Akcje",
    tags: "Tagi",
    filters: "Filtry",
    energy: "Energetyczność",
    protein: "Białko",
    fats: "Tłuszcze",
    carbs: "Węglowodany",
    micronutrients: "Mikroskładniki",
    macronutrients: "Makroskładniki",
    show: "Pokaż",
    clearAll: "Wyczyść wszystkie",
    createOption: "Dodaj „{{name}}”",

    noResultLabel: "Brak wyników",
    noResultDescription: "Spróbuj dostosować filtry lub kryteria wyszukiwania",
    clearFilters: "Wyczyść filtry",
    errorPlaceholderTitle: "Coś poszło nie tak",
    errorPlaceholderDescription: "Wystąpił błąd. Spróbuj ponownie później.",
    noDataAvailable: "Brak danych",
    noDataAvailablePlaceholder: "Brak danych do wyświetlenia",
    noFutureDataTitle: "Brak przyszłych danych",
    noFutureDataDescription:
      "Przyszłe dane pojawią się tutaj, gdy będą dostępne",
    noAccessDataTitle: "Ograniczony dostęp",
    noAccessDataDescription:
      "Nie masz dostępu do tych danych dla wybranego okresu",
    changeDateRange: "Zmień zakres dat",
    changeProperties: "Zmień właściwości",
    futureDescription: "Ta funkcja będzie dostępna w przyszłości",
    futureAccountDescription:
      "Ta funkcja wkrótce będzie dostępna dla Twojego konta",
    ownPropertyDescription: "To jest Twoja własna właściwość",

    accessLimited: "Ograniczony dostęp",
    accessLimitedForSomeDates: "Ograniczony dostęp dla niektórych dat",
    accessLimitedTooltipDescription:
      "Nie masz dostępu do danych dla niektórych dat w tym zakresie",
    accessLimitedAvailablePeriods: "Dostępne okresy:",

    pageOf: "Strona {{current}} z {{total}}",
    rowsPerPage: "Liczba wierszy:",
  },
  calendar: {
    months: {
      january: "Styczeń",
      february: "Luty",
      march: "Marzec",
      april: "Kwiecień",
      may: "Maj",
      june: "Czerwiec",
      july: "Lipiec",
      august: "Sierpień",
      september: "Wrzesień",
      october: "Październik",
      november: "Listopad",
      december: "Grudzień",
    },
    weekDaysShort: {
      monday: "Pon",
      tuesday: "Wt",
      wednesday: "Śr",
      thursday: "Czw",
      friday: "Pt",
      saturday: "Sob",
      sunday: "Ndz",
    },
    weekDaysMin: {
      monday: "Pn",
      tuesday: "Wt",
      wednesday: "Śr",
      thursday: "Cz",
      friday: "Pt",
      saturday: "So",
      sunday: "Nd",
    },
    periods: {
      thisMonth: "Ten miesiąc",
      monthToDate: "Od początku miesiąca",
      yearToDate: "Od początku roku",
      lastMonth: "Ostatni miesiąc",
      lastYear: "Ostatni rok",
      monthToEnd: "Do końca miesiąca",
      yearToEnd: "Do końca roku",
      thisYear: "Ten rok",
      nextMonth: "Następny miesiąc",
      next365Days: "Następne 365 dni",
    },
  },
  sidebar: {
    expandTooltip: "Rozwiń panel",
    collapseTooltip: "Zwiń panel",
    navigation: "Nawigacja główna",
    openNavigation: "Otwórz nawigację",
    closeNavigation: "Zamknij nawigację",
    search: "Szukaj",
    searchPlaceholder: "Szukaj…",
  },
  spotlight: {
    title: "Wyszukiwanie",
    placeholder: "Szukaj…",
    recent: "Niedawno szukane",
    clear: "Wyczyść",
    results: "Wyniki wyszukiwania ({{count}})",
    noResults: "Brak wyników",
    remove: "Usuń „{{name}}” z historii",
  },
  theme: {
    switchToDark: "Przełącz na tryb ciemny",
    switchToLight: "Przełącz na tryb jasny",
  },
  richTextEditor: {
    unreadable:
      "Nie udało się odczytać zapisanej treści. Edycja jest zablokowana, żeby nie nadpisać oryginału — zgłoś to do nas.",
    toolbar: "Formatowanie",
    zoomIn: "Powiększ",
    zoomOut: "Pomniejsz",
    pageGuides: "Strony PDF",
    paragraph: "Tekst zwykły",
    heading: "Nagłówek {{level}}",
    quote: "Cytat",
    fontSizeDefault: "Domyślny",
    bold: "Pogrubienie",
    italic: "Kursywa",
    underline: "Podkreślenie",
    strikethrough: "Przekreślenie",
    code: "Kod",
    textColor: "Kolor tekstu",
    resetColor: "Kolor domyślny",
    highlight: "Wyróżnienie",
    removeHighlight: "Usuń wyróżnienie",
    table: {
      label: "Tabela",
      insert: "Wstaw tabelę",
      addRowBefore: "Dodaj wiersz powyżej",
      addRowAfter: "Dodaj wiersz poniżej",
      deleteRow: "Usuń wiersz",
      addColumnBefore: "Dodaj kolumnę z lewej",
      addColumnAfter: "Dodaj kolumnę z prawej",
      deleteColumn: "Usuń kolumnę",
      toggleHeaderRow: "Wiersz nagłówka",
      mergeOrSplit: "Scal / podziel komórki",
      delete: "Usuń tabelę",
    },
    link: "Link",
    linkText: "Tekst",
    linkUrl: "Adres",
    removeLink: "Usuń link",
    image: "Obraz",
    imageFromDisk: "Wgraj z komputera",
    imageError: "Nie udało się dodać tego obrazu.",
    imageUrl: "Adres obrazu",
    imageAlt: "Opis",
    bulletList: "Lista punktowana",
    orderedList: "Lista numerowana",
    listStyle: "Styl listy",
    listStyles: {
      disc: "Kropka",
      circle: "Okrąg",
      square: "Kwadrat",
      decimal: "1, 2, 3",
      lowerAlpha: "a, b, c",
      upperAlpha: "A, B, C",
      lowerRoman: "i, ii, iii",
      upperRoman: "I, II, III",
    },
    taskList: "Lista zadań",
    textAlign: "Wyrównanie",
    alignLeft: "Do lewej",
    alignCenter: "Wyśrodkuj",
    alignRight: "Do prawej",
    alignJustify: "Wyjustuj",
    lineHeight: "Interlinia",
    lineHeightDefault: "Domyślna",
    specialCharacter: "Znak specjalny",
    undo: "Cofnij",
    redo: "Ponów",
    divider: "Linia oddzielająca",
    clearFormatting: "Wyczyść formatowanie",
  },
};

export default pl;
